import React, { FunctionComponent } from 'react';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconWorkHoursReport: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faFileSignature} />;

export { BrassIconWorkHoursReport };
